import React from 'react'
import Banner from '../components/Banner'
import Navigation from '../components/Navigation'
import Pricing from '../components/Pricing'
import Footer from '../components/Footer'

const PricingPage = () => {
  return (
    <div className="w-full bg-white">
      <Banner />
      <Navigation />
      <main>
        <section id="pricing">
          <Pricing />
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default PricingPage

